import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import TickerTape from "@/components/TickerTape";
import About from "@/components/About";
import WhatWeCover from "@/components/WhatWeCover";
import YouTubeSection from "@/components/YouTubeSection";
import SocialConnect from "@/components/SocialConnect";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";

const Home = () => {
  return (
    <div className="relative min-h-screen w-full bg-background" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <TickerTape />
        <About />
        <WhatWeCover />
        <YouTubeSection />
        <SocialConnect />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
